<template>
	<div class="sign">
		<div class="sign-search">
			<div class="btn-box">
				<van-field
					size="small"
					v-model="search.key"
					placeholder="请扫码SKU"
					right-icon="scan"
                    clearable
                    clear-trigger="always"
					:formatter="relationNumberFmt"
					@click-right-icon="scanSku"
					@keyup.13="getList()"
					@input="getList"
				/>
			</div>
			<div class="toSearch-box" :style="{'min-height': '55px'}">
				<button class="sign-toSearch" :style="{'height': '40%','min-height':'36px'}" @click="getList()">
					查询
				</button>
			</div>
		</div>

		<div class="sign-item">
			<template v-if="startSearch">
				<van-loading size="24px" vertical>加载中...</van-loading>
			</template>
			<template v-else>
				<template v-if="list.length">
					<ul class="bale-sku">
						<li @click="toDetail('/mobile/rePutawayDetail',item)" v-for="(item,index) in list" :key="index">
							<div>
								<div class="sign-list">
									<p>SKU：{{item.skuCode}}</p>
									<p>出库计划：{{item.shippingNo}}</p>
								</div>
								<div class="sign-list">
									<p>发货编码：{{item.sourceNo}}</p>
									<p>总数量：{{item.qty}}</p>
								</div>
							</div>
						</li>
					</ul>
				</template>
				<template v-else>
					<van-empty image="search" description="暂无数据" />
				</template>
			</template>
		</div>
	</div>
</template>

<script>
import { Icon, Badge, Picker, Popup, Field, Toast, Empty, List, Loading, Checkbox, Tab, Tabs } from 'vant';
import { GetInventoryStorageChangeAsync } from '@/api/mobile/rePutaway_api';
import { mapState,mapMutations } from 'vuex'
import util from "util/date";
import { debounce } from "util/util";
import { mixins } from "../mobileMixins";

export default {
	data() {
		return {
			search: {
                key:'',
				warehouseId: ''
			},
			list: [],
			startSearch: false
		}
	},

	components: {
		[Icon.name]: Icon,
		[Badge.name]: Badge,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[Toast.name]: Toast,
		[List.name]: List,
		[Empty.name]: Empty,
		[Loading.name]: Loading,
		[Checkbox.name]: Checkbox,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		[Field.name]: Field
	},

	mixins: [mixins],

	created() {
		this.init()
	},

	computed: {
		...mapState({ warehouse: state => state.common.warehouse })
	},

	mounted() {
	},

	methods: {
		init() {
			const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;
			this.$set(this.search, 'warehouseId', _warehouse.warehouseId)

			this.getList()
		},

		scanSku() {
			let that = this
			this.$wx.scanQRCode({
				needResult: 1,
				desc: 'scanQRCode desc',
				success: function (a) {
					that.$set(that.search, 'key', a.resultStr)
                    that.getList()
				}
			})
		},

		getList() {
			this.startSearch = true
			this.list = []

			GetInventoryStorageChangeAsync(this.search).then(res => {
				this.startSearch = false
				if (res.status === 200 && res.success) {
					const { response } = res

					if (!response.length) Toast('暂无匹配数据');

					this.list = response
				} else {
					Toast.fail(res.msg);
				}
			})
		},

		toDetail(url,item) {
			this.$router.push({ path: url, query: {inventoryStorageChangeID:item.inventoryStorageChangeID} })
		},
		
		relationNumberFmt(v) {
			return v.trim()
		},
	},

	watch: {
		$route: async function (newValue, from) {
			this.$nextTick(() => {
			})
		},
	}
}
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";

.sign-search .toSearch-box {
	flex: 0.4;
	margin-left: 3%;
	min-height: 90px;
}

.sign-toSearch {
	width: 100%;
	height: 65%;
	min-height: 80px;
	border-radius: 5px;
	border: 0;
	color: #fff;
	font-size: 20px;
}

::v-deep .van-tabs__nav--card {
	margin: 0;
	border: 0;
}

.sign-item .bale-container li {
	display: flex;
	height: 40px;
	line-height: 40px;
	& > div {
		flex: 1;
		text-align: center;
	}
}
</style>